import React from "react";
import BasicModal from "../_widgets/Modal/BasicModal";
import { Col, Form, Row } from "react-bootstrap";
import Input from "../_widgets/Input/Input";
import { warn } from "../../Wrapper/toast/toast";
import { MAX_30_CHARS, MAX_50_CHARS } from "../../Constants/stringConstants";
import { getInventoryCategories, removeInActive } from "../../Services/common";
import Dropdown from "../_widgets/Dropdown/Dropdown";

const AddEditModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addInventoryData,
  addInventory,
  editInventory,
  buttonLoading,
  setAddInventoryData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${addInventoryData.action} Inventory`}
      footer
      button2Text="Save"
      button2Click={() =>
        addInventoryData.action === "Add" ? addInventory() : editInventory(addInventoryData.id)
      }
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={6}>
                  <Input
                    isRequired={true}
                    placeholder="Enter Item Name"
                    type="text"
                    label="Item Name"
                    value={addInventoryData?.name}
                    onChange={(e) => {
                      if (e.target.value.length <= 30) {
                        setAddInventoryData({
                          ...addInventoryData,
                          name: e.target.value,
                        });
                      } else {
                        warn(MAX_30_CHARS);
                      }
                    }}
                  />
                </Col>
                <Col lg={6}>
                  <Dropdown
                    isRequired={true}
                    label={"Category"}
                    name={addInventoryData?.inventory_category_id}
                    onChange={(selectedValue) =>
                      setAddInventoryData({
                        ...addInventoryData,
                        inventory_category_id: selectedValue,
                      })
                    }
                    options={removeInActive(getInventoryCategories())}
                  />
                </Col>
                <Col lg={12}>
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter Remarks"
                    rows={4}
                    value={addInventoryData.remarks}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddInventoryData({
                          ...addInventoryData,
                          remarks: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default AddEditModal;
